/**
 * @fileoverview Social Compliance Settings View - controller for handling gdpr compliance for
 * social posts
 *
 * @author amywang@yext.com
 */
goog.module('yext.storm.SocialComplianceSettingsView');
goog.module.declareLegacyNamespace();

const yext = goog.require('yext');
const Model = goog.require('yext.mvc.Model');
const View = goog.require('yext.mvc.View');
const routes = goog.require('yext.storm.routes');

/**
 * @constructor
 * @extends {View}
 */
const SocialComplianceSettingsView = function() {
  /** @type {!jQuery} */
  this.$el = $('.js-social-compliance-settings-field');

  /** @type {!jQuery} */
  this.$viewMode = this.$el.find('.js-view-mode');

  /** @type {!jQuery} */
  this.$editAnonymizeFields = this.$el.find('.js-social-compliance-anon-data');

  /** @type {!jQuery} */
  this.$editDeleteFields = this.$el.find('.js-social-compliance-delete-data');

  /**
   * @type {Model}
   * @private
   */
  this.model_ = new Model();

  /**
   * @type {!Object}
   * @private
   */
  this.originalState_ = null;
};
goog.inherits(SocialComplianceSettingsView, View);

/** @enum */
SocialComplianceSettingsView.Mode = {
  VIEW: 1,
  EDIT: 2,
};

/** @const {string} */
SocialComplianceSettingsView.INPUT_PREFIX = 'settings.';

SocialComplianceSettingsView.prototype.init = function() {
  this.initModel_();
  this.bindModelToRender_();
  this.bindInputToModel_();
  this.bindToggleEdit_();
  this.bindSubmit_();

  return this;
};

/** @private */
SocialComplianceSettingsView.prototype.initModel_ = function() {
  this.model_.init({
    'mode': SocialComplianceSettingsView.Mode.VIEW,
    'anonymizeEnabled': this.$editAnonymizeFields.find('.js-enabled:checked').val() == 'true',
    'monthsUntilAnonymization': this.$editAnonymizeFields.find('select').val(),
    'deletionEnabled': this.$editDeleteFields.find('.js-enabled:checked').val() == 'true',
    'monthsUntilDeletion': this.$editDeleteFields.find('select').val(),
    'errors': [],
  });

  this.originalState_ = this.model_.raw();
};

/** @private */
SocialComplianceSettingsView.prototype.bindInputToModel_ = function() {
  this.$el.find('.js-settings-field').inputchange(function(e) {
    var changes = this.getValue_();
    this.model_.set('anonymizeEnabled', changes['anonymizeEnabled']);
    this.model_.set('monthsUntilAnonymization', changes['monthsUntilAnonymization']);
    this.model_.set('deletionEnabled', changes['deletionEnabled']);
    this.model_.set('monthsUntilDeletion', changes['monthsUntilDeletion']);
  }.bind(this));
};

/** @private */
SocialComplianceSettingsView.prototype.bindModelToRender_ = function() {
  this.model_.on('reset,change:mode', function() {
    this.render();
  }.bind(this));

  this.model_.on('change', function() {
    this.renderSubmit_();
    this.renderDisplay_();
  }.bind(this));

  this.model_.on('change:errors', function() {
    this.renderErrors_();
  }.bind(this));
};

/** @private */
SocialComplianceSettingsView.prototype.bindToggleEdit_ = function() {
  this.$el.on('click', function() {
    this.model_.set('mode', SocialComplianceSettingsView.Mode.EDIT);
  }.bind(this));

  this.$el.find('.js-cancel').on('click', function(e) {
    e.stopPropagation();
    this.model_.resetState(this.originalState_);
    this.model_.set('mode', SocialComplianceSettingsView.Mode.VIEW);
  }.bind(this));
};

/** @private */
SocialComplianceSettingsView.prototype.bindSubmit_ = function() {
  this.$el.find('form').on('submit', function(e) {
    e.stopPropagation();
    e.preventDefault();

    $.ajax({
      'url': routes.AccountSettings.updateSocialComplianceSettings(),
      'type': 'POST',
      'data': {'settings': this.getValue_()},
    })
      .success(function(data) {
        if (data['success']) {
          this.model_.set(
            'mode',
            SocialComplianceSettingsView.Mode.VIEW);
          this.originalState_ = this.model_.raw();
        } else if (data['error']) {
          this.model_.set('errors', data['errors']);
        }
      }.bind(this))
      .error(function() {
        this.model_.set(
          'errors',
          [yext.msg('There was an error saving your changes. Please try again')]);
      }.bind(this));
  }.bind(this));
};

SocialComplianceSettingsView.prototype.getValue_ = function() {
  var anonEnabled = this.$editAnonymizeFields.find('.js-enabled:checked').val() == 'true';
  var anonMonths = anonEnabled ? this.$editAnonymizeFields.find('.js-input').val() : 0;
  var deleteEnabled = this.$editDeleteFields.find('.js-enabled:checked').val() == 'true';
  var deleteMonths = deleteEnabled ? this.$editDeleteFields.find('.js-input').val() : 0;
  return {
    'anonymizeEnabled': anonEnabled,
    'monthsUntilAnonymization': anonMonths,
    'deletionEnabled': deleteEnabled,
    'monthsUntilDeletion': deleteMonths,
  };
};

/**
 * @private
 * @return true if there have been any changes to the form
 */
SocialComplianceSettingsView.prototype.hasChanges_ = function() {
  var changes = this.model_.findDelta(this.originalState_).delta;
  for (var k in changes) {
    if (k == 'mode' || k == 'errors') {
      continue;
    } else {
      return true;
    }
  }
  return false;
};

/** @override */
SocialComplianceSettingsView.prototype.render = function() {
  this.renderMode_();
  this.renderDisplay_();
  this.renderErrors_();
};

/** @private */
SocialComplianceSettingsView.prototype.renderErrors_ = function() {
  var errors = this.model_.get('errors');
  if (errors && errors.length) {
    this.$el.find('.js-error').html(errors.join('<br/>')).show();
  } else {
    this.$el.find('.js-error').empty().hide();
  }
};

/** @private */
SocialComplianceSettingsView.prototype.renderMode_ = function() {
  this.$el.find('.js-edit-mode')
    .toggle(this.model_.get('mode') ==
                  SocialComplianceSettingsView.Mode.EDIT);
  this.$viewMode.toggle(this.model_.get('mode') ==
                        SocialComplianceSettingsView.Mode.VIEW);
};

/** @private */
SocialComplianceSettingsView.prototype.renderSubmit_ = function() {
  this.$el.find('.js-submit').prop('disabled', !this.hasChanges_());
};

/** @private */
SocialComplianceSettingsView.prototype.renderDisplay_ = function() {
  var anonEnabled = this.model_.get('anonymizeEnabled') == true;
  var anonMonths = this.model_.get('monthsUntilAnonymization');
  var deleteEnabled = this.model_.get('deletionEnabled') == true;
  var deleteMonths = this.model_.get('monthsUntilDeletion');

  if (!anonEnabled && !deleteEnabled) {
    this.$viewMode.html(yext.msg('Disabled'));
    return;
  }

  this.$viewMode.empty();

  if (anonEnabled) {
    if (anonMonths === 1) {
      this.$viewMode.append(yext.msg(
        'Anonymize social posts after <span class=setting-value">{0}</span> month',
        anonMonths));
    } else {
      this.$viewMode.append(yext.msg(
        'Anonymize social posts after <span class=setting-value">{0}</span> months',
        anonMonths));
    }
  }

  if (anonEnabled && deleteEnabled) {
    this.$viewMode.append('<br>');
  }

  if (deleteEnabled) {
    this.$viewMode.append(
      yext.msg('Permanently delete social posts after <span class="setting-value">{0}</span> months',
        deleteMonths));
  }
};

exports = SocialComplianceSettingsView;
